export const setting = {
  record_outgoing: {
    title: 'Rekaman panggilan keluar',
    warning_text: 'Rekaman panggilan untuk anda',
    warning_link_text: 'Paket PBX',
    warning_text_end: ''
  },
  on_record: 'Nyalakan Rekaman panggilan?',
  off_record: 'Matikan Rekaman panggilan ?'
};
